/**
 * @generated SignedSource<<de286a97e3128891f4cbbc18d16b72a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuizSubmissionsTable_ContentUsageFragment$data = {
  readonly passPercentage: number | null;
  readonly product: {
    readonly adminCanLearnMode: boolean;
  } | null;
  readonly " $fragmentType": "QuizSubmissionsTable_ContentUsageFragment";
};
export type QuizSubmissionsTable_ContentUsageFragment$key = {
  readonly " $data"?: QuizSubmissionsTable_ContentUsageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuizSubmissionsTable_ContentUsageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuizSubmissionsTable_ContentUsageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "passPercentage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "adminCanLearnMode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "4f0c3fb5e78b06d5461d9d249c2ac808";

export default node;
